import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

type LogClickRemoveFolderParams = {
  folderSno: number;
};

export const useLogClickRemoveFolder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ folderSno }: LogClickRemoveFolderParams) => {
      logAnalyticsEvent({
        name: 'CLICK_REMOVE_FOLDER',
        analytics: {
          FOLDER_SNO: folderSno.toString(),
        },
      });
    },
    [logAnalyticsEvent],
  );
};
